<template>
  <WdsButtonGhost
    secondary
    :href="path"
    :title="column?.job.name ?? ''"
    class="tw-max-w-[310px] tw-min-h-[46px]"
  >
    <WdsStack class="hire-po-name-column" direction-column justify-center>
      <span>
        {{ column?.job.name ?? '' }}
      </span>
      <WdsText :sub-text="column?.purchaseOrderNumber ?? ''" />
    </WdsStack>
  </WdsButtonGhost>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost, WdsStack, WdsText } from '@worksome/wds-components'
import { graphql, FragmentType, useFragment } from '@/gql'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const frag = graphql(`
  fragment HireTitleNavigationPoNumberColumn on Hire {
    id
    purchaseOrderNumber
    job {
      id # for cache indexing
      name
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof frag>
}>()

const column = computed(() => {
  if (!props.row) return null

  return useFragment(frag, props.row)
})

const path = computed(() =>
  laravelNamedRoute(namedRoutes.hires.hire.view, { hire: column.value?.id, tab: 'overview' }),
)
</script>

<style lang="scss">
.hire-po-name-column {
  max-width: 300px;
  span,
  .wds-text-secondary {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
